(() => {
  if (window.lhcPremiumProductInitialized) return;
  window.lhcPremiumProductInitialized = true;

  const body = document.body;
  let previousOverflow = '';

  const openDialog = (dialog) => {
    if (!dialog || typeof dialog.showModal !== 'function') return;
    previousOverflow = body.style.overflow;
    dialog.showModal();
    body.style.overflow = 'hidden';
  };

  const closeDialog = (dialog) => {
    if (!dialog || !dialog.open) return;
    dialog.close();
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-lhc-dialog-open]');
    if (opener) {
      openDialog(document.getElementById(opener.dataset.lhcDialogOpen));
      return;
    }

    const closer = event.target.closest('[data-lhc-dialog-close]');
    if (closer) {
      closeDialog(closer.closest('dialog'));
      return;
    }

    const dialog = event.target.closest('dialog.lhc-drawer');
    if (dialog && event.target === dialog) closeDialog(dialog);
  });

  document.addEventListener('close', (event) => {
    if (!event.target.matches('dialog.lhc-drawer')) return;
    body.style.overflow = previousOverflow;
  }, true);

  document.addEventListener('change', (event) => {
    const section = event.target.closest('.lhc-premium-product');
    if (!section || !event.target.closest('variant-selects')) return;
    updateDeliveryEstimate(section.querySelector('[data-lhc-delivery-estimate]'));
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    section.classList.add('is-changing');
    window.setTimeout(() => section.classList.remove('is-changing'), 240);
  });

  const addBusinessDays = (startDate, days) => {
    const date = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    let added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      const weekday = date.getDay();
      if (weekday !== 0 && weekday !== 6) added += 1;
    }
    return date;
  };

  const formatDeliveryRange = (minDate, maxDate) => {
    const sameMonth = minDate.getMonth() === maxDate.getMonth() && minDate.getFullYear() === maxDate.getFullYear();
    const day = (date) => date.toLocaleDateString('en-GB', { day: 'numeric' });
    const month = (date) => date.toLocaleDateString('en-GB', { month: 'short' });
    if (sameMonth) return `${day(minDate)}–${day(maxDate)} ${month(maxDate)}`;
    return `${day(minDate)} ${month(minDate)}–${day(maxDate)} ${month(maxDate)}`;
  };

  const updateDeliveryEstimate = (estimate) => {
    if (!estimate) return;
    const minDays = Number.parseInt(estimate.dataset.minDays, 10);
    const maxDays = Number.parseInt(estimate.dataset.maxDays, 10);
    const output = estimate.querySelector('[data-lhc-delivery-dates]');
    const label = estimate.querySelector('[data-lhc-delivery-label]');
    const note = estimate.querySelector('[data-lhc-delivery-note]');
    const section = estimate.closest('.lhc-premium-product');
    const selectedValues = section
      ? Array.from(section.querySelectorAll('variant-selects input[type="radio"]:checked, variant-selects select')).map((control) => control.value)
      : [];
    const editionValues = selectedValues.filter((value) => /digital|printed|perfect-bound/i.test(value));
    const isDigitalOnly = estimate.dataset.digitalOnly === 'true';
    const isDigital = isDigitalOnly || (editionValues.length > 0 && editionValues.every((value) => /digital/i.test(value)));

    estimate.classList.toggle('is-digital', isDigital);
    if (isDigital) {
      if (label) label.textContent = estimate.dataset.digitalLabel || 'Digital access';
      if (output) output.textContent = estimate.dataset.digitalMessage || 'Available after checkout';
      if (note) note.textContent = estimate.dataset.digitalNote || '';
      return;
    }

    if (label) label.textContent = estimate.dataset.physicalLabel || 'Estimated delivery';
    if (note) note.textContent = estimate.dataset.physicalNote || '';
    if (!output || !Number.isFinite(minDays) || !Number.isFinite(maxDays) || maxDays < minDays) return;
    output.textContent = formatDeliveryRange(addBusinessDays(new Date(), minDays), addBusinessDays(new Date(), maxDays));
  };

  const updateMobilePurchase = (section) => {
    const bar = section.querySelector('[data-lhc-mobile-purchase]');
    const mainButton = section.querySelector('.lhc-buy-buttons .product-form__submit');
    if (!bar || !mainButton) return;

    const selectedValues = Array.from(
      section.querySelectorAll('variant-selects input[type="radio"]:checked, variant-selects select')
    ).map((control) => control.value).filter((value) => value && value !== 'Default Title');
    const variantOutput = bar.querySelector('[data-lhc-mobile-variant]');
    const priceOutput = bar.querySelector('[data-lhc-mobile-price]');
    const mobileButton = bar.querySelector('[data-lhc-mobile-add]');
    const priceBox = section.querySelector('.lhc-price .price');
    const price = priceBox?.classList.contains('price--on-sale')
      ? priceBox.querySelector('.price__sale .price-item--sale')
      : priceBox?.querySelector('.price__regular .price-item--regular');

    if (variantOutput && selectedValues.length) variantOutput.textContent = selectedValues.join(' · ');
    if (priceOutput && price) priceOutput.textContent = price.textContent.trim();
    if (mobileButton) {
      mobileButton.disabled = mainButton.disabled;
      mobileButton.textContent = mainButton.textContent.trim();
    }
  };

  const initializeMobilePurchase = (section) => {
    const bar = section.querySelector('[data-lhc-mobile-purchase]');
    if (!bar) return;

    updateMobilePurchase(section);
    bar.querySelector('[data-lhc-mobile-add]')?.addEventListener('click', () => {
      const mainButton = section.querySelector('.lhc-buy-buttons .product-form__submit');
      if (mainButton && !mainButton.disabled) mainButton.click();
    });

    const observedArea = section.querySelector('.lhc-purchase-panel');
    if (observedArea) {
      new MutationObserver(() => updateMobilePurchase(section)).observe(observedArea, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled']
      });
    }
  };

  const initializeWallStudiesBackLink = (section) => {
    const panel = section.querySelector('.lhc-purchase-panel');
    if (!panel || panel.querySelector('.lhc-series-back-link')) return;

    const title = panel.querySelector('.lhc-product-title h1');
    const productPath = window.location.pathname.toLowerCase();
    const isWallStudies =
      productPath.includes('/products/wall-studies-') ||
      (title && title.textContent.trim().toUpperCase().startsWith('WALL STUDIES'));

    if (!isWallStudies) return;

    const link = document.createElement('a');
    link.className = 'lhc-series-back-link';
    link.href = '/collections/wall-studies';
    link.setAttribute('aria-label', 'Back to Wall Studies');
    link.innerHTML = '<span aria-hidden="true">←</span><span>Wall Studies</span>';

    const eyebrow = panel.querySelector('.lhc-eyebrow');
    if (eyebrow) panel.insertBefore(link, eyebrow);
    else panel.prepend(link);
  };

  document.querySelectorAll('[data-lhc-delivery-estimate]').forEach(updateDeliveryEstimate);
  document.querySelectorAll('.lhc-premium-product').forEach((section) => {
    initializeWallStudiesBackLink(section);
    initializeMobilePurchase(section);
  });

})();

(() => {
  const currentScript = Array.from(document.scripts).find((script) => script.src && script.src.includes('lhc-premium-product.js'));
  if (!currentScript) return;

  const assetUrl = (filename) => {
    const url = new URL(currentScript.src, window.location.href);
    url.pathname = url.pathname.replace(/lhc-premium-product\.js$/, filename);
    url.searchParams.set('lhc_frame', window.location.pathname.includes('mediterranean-studies-windswept-canvas') ? '20261014-printumo-windswept-v1' : (window.location.pathname.includes('mediterranean-studies-the-shore-canvas') ? '20261014-printumo-shore-v1' : (window.location.pathname.includes('mediterranean-studies-the-hour-canvas') ? '20261014-printumo-hour-v1' : (window.location.pathname.includes('mediterranean-studies-the-terrace-canvas') ? '20261014-printumo-terrace-v2' : '20261014-printumo-salt-stone'))));
    if (window.location.pathname.includes('mediterranean-studies-the-current-canvas')) url.searchParams.set('lhc_frame', '20261016-printumo-the-current-v1');
    if (window.location.pathname.includes('mediterranean-studies-the-blue-distance-canvas')) url.searchParams.set('lhc_frame', '20261016-printumo-blue-distance-v1');
    if (window.location.pathname.includes('mediterranean-studies-the-wild-light-canvas')) url.searchParams.set('lhc_frame', '20261016-printumo-wild-light-v1');
    if (window.location.pathname.includes('mediterranean-studies-the-clearing-canvas')) url.searchParams.set('lhc_frame', '20261016-printumo-clearing-v1');
    if (window.location.pathname.includes('mediterranean-studies-the-sunshower-canvas')) url.searchParams.set('lhc_frame', '20261016-printumo-sunshower-v1');
    if (window.location.pathname.includes('mediterranean-studies-high-summer-canvas')) url.searchParams.set('lhc_frame', '20261016-printumo-high-summer-v1');
    if (window.location.pathname.includes('mediterranean-studies-the-red-veil-canvas')) url.searchParams.set('lhc_frame', '20261016-printumo-red-veil-v1');
    if (window.location.pathname.includes('mediterranean-studies-crimson-undertow-canvas')) url.searchParams.set('lhc_frame', '20261016-printumo-crimson-undertow-v1');
    if (window.location.pathname.includes('mediterranean-studies-black-tide-canvas')) url.searchParams.set('lhc_frame', '20261016-printumo-black-tide-v1');
    if (window.location.pathname.includes('mediterranean-studies-the-sail-canvas')) url.searchParams.set('lhc_frame', '20261017-printumo-the-sail-v1');
    if (window.location.pathname.includes('mediterranean-studies-the-passage-canvas')) url.searchParams.set('lhc_frame', '20261017-printumo-passage-v1');
    if (/\/products\/figure-study-[a-z0-9-]+-canvas(?:-art)?(?:\/|$)/.test(window.location.pathname)) url.searchParams.set('lhc_frame', '20261023-printumo-figure-canvas-v2');
    return url.toString();
  };

  if (!document.querySelector('link[data-lhc-frame-details]')) {
    const stylesheet = document.createElement('link');
    stylesheet.rel = 'stylesheet';
    stylesheet.href = assetUrl('lhc-frame-details.css');
    stylesheet.dataset.lhcFrameDetails = 'true';
    document.head.appendChild(stylesheet);
  }

  if (!document.querySelector('script[data-lhc-frame-details]')) {
    const script = document.createElement('script');
    script.src = assetUrl('lhc-frame-details.js');
    script.defer = true;
    script.dataset.lhcFrameDetails = 'true';
    document.head.appendChild(script);
  }
})();

(() => {
  const cloneNativePayPalIcon = () => {
    const source = document.querySelector('svg[aria-labelledby="pi-paypal"]');
    if (!source) return null;

    const svg = source.cloneNode(true);
    svg.removeAttribute('aria-labelledby');
    svg.setAttribute('aria-hidden', 'true');
    svg.querySelector('title')?.remove();
    svg.classList.remove('icon', 'icon--full-color');
    svg.classList.add('lhc-payment-icon');
    return svg;
  };

  const ensurePayPalIcon = () => {
    document.querySelectorAll('.lhc-premium-product .lhc-payment-methods ul').forEach((list) => {
      if (list.querySelector('[data-lhc-paypal-icon]')) return;

      const svg = cloneNativePayPalIcon();
      if (!svg) return;

      const item = document.createElement('li');
      item.dataset.lhcPaypalIcon = 'true';
      item.appendChild(svg);

      const label = document.createElement('span');
      label.className = 'visually-hidden';
      label.textContent = 'PayPal';
      item.appendChild(label);
      list.appendChild(item);
    });
  };

  const initialize = () => {
    ensurePayPalIcon();
    document.querySelectorAll('.lhc-premium-product').forEach((section) => {
      new MutationObserver(ensurePayPalIcon).observe(section, {
        childList: true,
        subtree: true
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', ensurePayPalIcon);
})();
